/* eslint-disable import/no-anonymous-default-export */
export default [
  {
    period: "2017 - Present",
    title: "University of Rwanda",
    subtitle: "Bachelors degree",
    description:
      "I am a student at the University of Rwanda, college of medicine and health sciences in the anesthesia department where I am gaining all knowledge associated with anesthesia provision and critical care",
  },
];
